import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: any) => ({
  fileInputWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%', 
    '& > label': {
      display: 'flex',
      flexWrap: 'wrap',
      color: theme.colors.black,
      fontSize: '14px',
      marginTop: '16px',
      marginBottom: '7px',
      fontWeight: 'bold',
      width: '100%',
      alignItems: 'center',
      '& > small': {
        fontSize: '13px',
        color: theme.colors.grey[540],
        fontWeight: 'normal',
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
        marginLeft: 'auto',
        '& > svg': {
          width: '15px',
          height: '15px',
        },
      },
    },
  },
  help: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    marginBottom: '7px',
    '& > small': {
      fontSize: '13px',
      color: theme.colors.grey[540],
      display: 'flex',
      gap: '4px',
      alignItems: 'center',
      marginLeft: 'auto',
    },
  },
  fileInput: {
    width: '100%',
    maxWidth: 'calc(100% - 2px)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.colors.grey[325],
    borderRadius: "10px",
    backgroundColor: theme.colors.white,
    minHeight: "200px",
    display: "flex",
    overflow: "auto",
    flexDirection: 'column',
    position: 'relative',
    '&:focus': {
      outline: "none",
    },
    '&.disabled': {
      color: theme.colors.grey[560],
      backgroundColor: theme.colors.grey[75],
    },
  },
  hidden: {
    display: 'none',
    pointerEvents: 'none',
  },
  filesList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    position: 'relative',
    width: 'calc(100% - 20px)',
    height: 'calc(100% - 20px)',
    maxHeight: 'calc(100% - 20px)',
    flex: '1 0 100%',
    padding: "10px",
    borderRadius: "inherit",
  },
  fileWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  addFile: {
    backgroundColor: theme.colors.grey[125],
    borderRadius: "10px",
    borderWidth: "1px",
    borderStyle: "dashed",
    borderColor: theme.colors.grey[300],
    width: "80px",
    height: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "10px 10px",
    '& svg': {
      color: theme.colors.grey[540],
      width: '24px',
      height: '24px',
    },
  },
  captionName: {
    maxWidth: '80px',
    fontSize: "13px",
    lineHeight: '13px',
    height: '16px',
    maxHeight: '16px',
    textAlign: 'center',
    whiteSpace: 'break-spaces',
    overflowWrap: 'break-word',
    marginBottom: '0',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(238,238,238,0.5)',
  },
  spinner: {
    '& svg': {
      color: theme.colors.primaryBlue[500]
    }
  },
  captions: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px',
    gap: '8px',
  },
  caption: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.colors.grey[550],
    fontSize: "12px",
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& > svg': {
        width: '15px',
        height: '15px',
      },
    },
  },
  draganddrop: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    borderWidth: '5px',
    borderStyle: 'dashed',
    borderColor: theme.colors.black,
    backgroundColor: 'rgba(153,153,153,0.9)',
    color: theme.colors.black,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '36px',
    zIndex: theme.zIndex.dragAndDrop,
  },
}));

export default useStyles;